import { useCallback, useState } from 'react';
import getDealStatuses from '../../api/deals/getDealStatuses';
import Select from '../Select/Select';

// Статус сделки в фильтре списка лидов: все статусы справочника, без привязки к форме оплаты
// (в отличие от SelectDealStatuses, который сужает список под форму оплаты сделки).
const SelectLeadDealStatus = ({ handleSetSelect, handleSetState, style, ...props }) => {
  const [options, setOptions] = useState([]);
  const onFocus = useCallback(() => {
    getDealStatuses().then((res) => setOptions((res.data || []).map((item) => ({ value: item.id, label: item.title }))));
  }, []);

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={options}
      title={'Статус сделки'}
      placeholder={'Выберите статус сделки'}
      onFocus={onFocus}
      style={style}
      {...props}
    />
  );
};

export default SelectLeadDealStatus;
